import { CommonTable } from "components/atoms/table/AntdTable";
import { ReportInventoryCameraRow } from "api/interfaces/reportInterface.interface";
import { BasePagination } from "api/interfaces/commonInterface.interface";
import { TableColumnsType } from "antd";

type Props = {
  columns: TableColumnsType<ReportInventoryCameraRow>;
  cameraQueryInfo: BasePagination;
  onChangePage: (page: number, totalRows: number) => void;
  isLoading: boolean;
  dataSource: ReportInventoryCameraRow[];
};

export default function CameraPresenter(props: Props) {
  return (
    <CommonTable
      columns={props.columns}
      dataSource={props.dataSource}
      queryInfo={props.cameraQueryInfo}
      loading={props.isLoading}
      onChangePage={props.onChangePage}
    />
  );
}
